import React from "react";
import styles from '../RecentOrder/RecentOrder.module.scss';

const NoAuthenticatedDevices: React.FC = () => {
    return (
        <>
            <div className={`${styles.profile_inn_wrap} text-center`}>
                <div className={`${styles.profile_content_wrap} mx-auto`}>
                    <div className={`${styles.inn_content_wrap} mx-auto`}>
                        <h1 className="h-24 font-Cls medium_text">
                            You have no other <br /> Authenticated Devices.
                        </h1>
                    </div>
                </div>
                <hr className="custom_hr_sty cz-my-40 d-none d-md-block"></hr>
            </div>
        </>
    );
};
export default NoAuthenticatedDevices;
